// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CreditAssessmentService = {};

CreditAssessmentService.getCreditAssessment = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      `/ApkLoan/ApkLoanCreditAssessment?pageSize=` +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&applicationid=" +
      data?.applicationid +
      "&name=" +
      data?.name +
      "&endApplicationDate=" +
      data?.endApplicationDate +
      "&startApplicationDate=" +
      data?.startApplicationDate,
    method: "get",
    headers: {},
  });
};

CreditAssessmentService.posPhoneVerification = function (data) {
  return lossClient({
    url: `/PhoneVerification/add`,
    method: "post",
    data: data,
  });
};

CreditAssessmentService.posBankverification = function (data) {
  return lossClient({
    url: `/bankverification/add`,
    method: "post",
    data: data,
  });
};

CreditAssessmentService.getPhoneverification = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      `/phoneverification/search?pageSize=` +
      data.pageSize +
      `&pageIndex=0` +
      decrementIndex +
      `&code=` +
      data?.code,
    method: "get",
  });
};

CreditAssessmentService.getBankverification = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      `/bankverification/search?pageSize=` +
      data.pageSize +
      `&pageIndex=0` +
      decrementIndex +
      `&code=` +
      data?.code,
    method: "get",
  });
};

CreditAssessmentService.putProceed = function (data) {
  return lossClient({
    url: `/bankverification/Proceed`,
    method: "put", 
    headers: {
      "x-requestId": data.id,
    },
    data: data.data,
  });
};

export default CreditAssessmentService;
